import { vuexfireMutations, firestoreAction } from 'vuexfire'
import { firestore } from '@/firestore';
import axios from "axios";

export default {
    state: {
        program: null,
        museum: null,
        roomContent: null,
        questions: [],
        videoPlayer: null,
        isVideoPlaying: false,
        allowLeave: false,
        mediaUnlocked: false
    },
    mutations: {
        ...vuexfireMutations,
        setShadowProgram(state, program) {
            state.program = program;
        },
        setShadowMuseum(state, museum) {
            state.museum = museum;
        },
        setVideoPlayer(state, videoPlayer) {
            state.videoPlayer = videoPlayer;
        },
        setIsVideoPlaying(state, isVideoPlaying) {
            state.isVideoPlaying = isVideoPlaying;
        },
        setAllowLeave(state, allowLeave) {
            state.allowLeave = allowLeave;
        },
        setMediaUnlocked(state, value) {
            state.mediaUnlocked = value;
        },
        resetSchoolState(state) {
            state.program = null;
            state.roomContent = null;
            state.videoPlayer = null;
            state.isVideoPlaying = false;
            state.allowLeave = false;
        }
    },
    actions: {
        async getContent({ commit }, roomName) {
            try {
                const res = await axios.post(`${process.env.VUE_APP_BASE_URL}/twilio/connect`, {
                    roomName,
                    role: "shadow"
                });

                commit("setShadowProgram", res.data.program);
                commit("setShadowMuseum", res.data.museum);

                return {
                    accessToken: res.data.roomData.accessToken,
                    roomSid: res.data.roomData.roomSid,
                    roomCreatedAt: res.data.roomData.roomCreatedAt
                }
            } catch (e) {
                console.log(e);
                throw e;
            }
        },
        bindRoomContent: firestoreAction(async ({ rootState, bindFirestoreRef }) => {
            try {
                await bindFirestoreRef('roomContent', firestore.collection('rooms').doc(rootState.twilio.room.sid));
                await bindFirestoreRef('questions', firestore.collection(`rooms/${rootState.twilio.room.sid}/questions`).orderBy("asked", "asc"));
            } catch (e) {
                throw e;
            }
        }),
        unbindRoomContent: firestoreAction(({ unbindFirestoreRef }) => {
            unbindFirestoreRef('roomContent');
            unbindFirestoreRef('questions');
        })
    }
}